import {
  type HeapAPI,
  type HeapConfig,
  type HeapMethodArgs,
} from "@/types/heap";

export const initHeap = () => {
  const HEAP_CLIENT_ID = import.meta.env.VITE_HEAP_CLIENT_ID;

  if (!HEAP_CLIENT_ID) {
    console.warn("[Heap] VITE_HEAP_CLIENT_ID is not defined.");
    return;
  }
  window.heapReadyCb = window.heapReadyCb || [];
  window.heap = window.heap || ({} as HeapAPI);

  window.heap.load = (envId: string, clientConfig?: HeapConfig) => {
    if (!window.heap) {
      return;
    }

    window.heap.envId = envId;
    window.heap.clientConfig = clientConfig || {};
    window.heap.clientConfig.shouldFetchServerConfig = false;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://cdn.us.heap-api.com/config/${envId}/heap_config.js`;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    const methodList = [
      "init",
      "startTracking",
      "stopTracking",
      "track",
      "resetIdentity",
      "identify",
      "getSessionId",
      "getUserId",
      "getIdentity",
      "addUserProperties",
      "addEventProperties",
      "removeEventProperty",
      "clearEventProperties",
      "addAccountProperties",
      "addAdapter",
      "addTransformer",
      "addTransformerFn",
      "onReady",
      "addPageviewProperties",
      "removePageviewProperty",
      "clearPageviewProperties",
      "trackPageview",
    ] as const;

    const proxyFn = (method: string) => {
      return (...args: HeapMethodArgs) => {
        if (window.heapReadyCb) {
          window.heapReadyCb.push({
            name: method,
            fn: () => {
              const heapMethod = window.heap?.[method];
              if (typeof heapMethod === "function") {
                heapMethod(...args);
              }
            },
          });
        }
      };
    };

    for (const method of methodList) {
      window.heap[method] = proxyFn(method) as never;
    }
  };

  window.heap.load(HEAP_CLIENT_ID);
};
